import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface StarlyToast {
  id?: number;
  status: 'info' | 'pending' | 'success' | 'error' | 'timeout';
  title: string;
  description?: string;
  showRefresh?: boolean;
  icon?: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class StarlyToastService {
  private toasts: StarlyToast[] = [];
  public currentToast$: BehaviorSubject<StarlyToast | null> = new BehaviorSubject<StarlyToast | null>(null);

  constructor() {}

  present(toast: StarlyToast) {
    toast.id = new Date().getTime();
    if (toast.duration) {
      this.expire(toast.id, toast.duration);
    }
    this.toasts.push(toast);
    this.currentToast$.next(toast);
    return toast.id;
  }

  remove(id: number) {
    const toast = this.toasts.find((t) => t.id === id);
    if (toast) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
      if (this.toasts.length > 0) {
        this.currentToast$.next(this.toasts[0]);
      } else {
        this.currentToast$.next(null);
      }
    }
  }

  clear() {
    this.toasts = [];
  }

  expire(toastId: number, duration: number) {
    setTimeout(() => {
      this.remove(toastId);
    }, duration);
  }
}
